import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GetUsabilityByCompanyIdAPI } from '../../API/LogsAPI';
import CardHeader from '../../antd/components/CardHeader';
import Loader from '../../Components/Shared/Loader';
import TableDefault from '../../Components/Shared/TableDefault';
import useLoading from '../../Hooks/useLoading';
import { IResponseProps } from '../../Interfaces/IResponseProps';
import { LogsModel } from '../../Models/LogsModel';
import { LogsColumns } from '../../Static/LogsColumns';
import Select from 'react-select';
import { AllActions, AllScreens, AllSeverities } from '../../Utils/AllLogsTypes';
import { ISelectProps } from '../../Interfaces/ISelectProps';

export default function LogsAction () {
    const { id } = useParams();
    const { loading, toggleLoading } = useLoading();
    const [ total, setTotal ] = useState<number>(0);
    const [ logs, setLogs ] = useState<LogsModel[]>([]);
    const [ search, setSearch ] = useState<string>("");
    const [ severity, setSeverity ] = useState<ISelectProps>();
    const [ severityText, setSeverityText ] = useState<string>("");
    const [ action, setAction ] = useState<ISelectProps>();
    const [ actionText, setActionText ] = useState<string>("");
    const [ screen, setScreen ] = useState<ISelectProps>();
    const [ screenText, setScreenText ] = useState<string>("");

    const getUsabilities = async (page?: number) => {
        try {
            toggleLoading(true);
            let text = search == null || search === "" ? "all" : search;
            let textSeverity = severityText == null || severityText === "" ? "all" : severityText;
            let textScreen = screenText == null || screenText === "" ? "all" : screenText;
            let textAction = actionText == null || actionText === "" ? "all" : actionText;

            await GetUsabilityByCompanyIdAPI(id ?? "", textSeverity, textScreen, textAction, page, 7, text).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setLogs(resp.data.items);
                    setTotal(resp.data.total);
                }
            }).finally(() => toggleLoading(false));

        } catch (error: any) {
            toggleLoading(false);
            toast.error(error);
        }
    }

    useEffect(() => {
        getUsabilities();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ severityText, actionText, screenText ]);

    return (
        <div className='card ml-2 mr-2'>
            {loading && <Loader />}
            <CardHeader
                pageName={"Logs de Ações"}
                hasPageBefore={false}
            />
            <div className='card-body'>
                <div className='d-flex align-items-center justify-content-between mb-2'>
                    <Select
                        value={severity}
                        className="w-25"
                        options={AllSeverities}
                        placeholder="Selecione a severidade..."
                        onChange={(e: any) => { setSeverity(e); setSeverityText(e.value) }}
                        classNamePrefix="select"
                    />
                    <Select
                        value={action}
                        className="w-25 ms-3"
                        options={AllActions}
                        placeholder="Selecione a ação..."
                        onChange={(e: any) => { setAction(e); setActionText(e.value) }}
                        classNamePrefix="select"
                    />
                    <Select
                        value={screen}
                        className="w-25 ms-3"
                        options={AllScreens}
                        placeholder="Selecione a tela..."
                        onChange={(e: any) => { setScreen(e); setScreenText(e.value) }}
                        classNamePrefix="select"
                    />
                    <input
                        onBlur={() => getUsabilities()}
                        className="form-control w-25 ms-3"
                        placeholder="buscar log..."
                        onChange={(e: any) => setSearch(e.target.value)}
                    />
                </div>
                <TableDefault
                    columns={LogsColumns}
                    rows={logs}
                    hasHeader={true}
                    hasPagination={true}
                    changePage={getUsabilities}
                    lastColumnIsAction={false}
                    total={total}
                    hasTitleOnLines={false}
                />
            </div>
        </div>
    )
}